"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteRequest = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
/**
 * This is used by the core types to perform remote requests
 */
class RemoteRequest {
    static request(payload, retry = 0) {
        return new Promise((accept, reject) => {
            if (retry >= 0) {
                RemoteRequest._send(payload).then(accept).catch((err) => {
                    const newretry = retry - 1;
                    if (newretry < 0) {
                        return reject(err);
                    }
                    console.error("RemoteRequest.request() - retry number " + newretry);
                    console.error(err);
                    setTimeout(() => {
                        RemoteRequest.request(payload, newretry).then(accept).catch(reject);
                    }, 500);
                });
            }
            else {
                return reject(new Error("RemoteRequest.request() - attempted all retries without success"));
            }
        });
    }
    static _send(payload) {
        return new Promise((accept, reject) => {
            const endpoint = payload.options.server === "dev" ? "http://localhost:9000/2015-03-31/functions/function/invocations" : "https://3gbnq7wuw2.execute-api.ap-southeast-2.amazonaws.com/main/xrutils";
            const reqopts = {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            };
            (0, node_fetch_1.default)(endpoint, reqopts)
                .then((res) => {
                if (res.ok) {
                    try {
                        return res.json();
                    }
                    catch (err) {
                        return new Error("RemoteRequest.request() - critical error occured, cannot proceed");
                    }
                }
                return new Error("RemoteRequest.request() - unexpected error occured, cannot proceed. error message is " + res.statusText);
            })
                .then((json) => {
                if (json instanceof Error) {
                    reject(json);
                }
                else {
                    accept(json);
                }
            });
        });
    }
}
exports.RemoteRequest = RemoteRequest;
